import { toApiLocale } from './utils/localeUtils';

// const BASE = process.env.NODE_ENV === 'production' ? 'http://47.76.186.202:8080' : '';
const BASE = '';

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
}

async function request(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, { ...options, credentials: 'include' });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.message || res.statusText);
    err.code = body.code;
    err.status = res.status;
    throw err;
  }
  return res.json();
}

function post(path, data) {
  return request(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
}

function csrfPost(path, data) {
  const csrfToken = getCookie('XSRF-TOKEN');
  return request(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(csrfToken ? { 'X-XSRF-TOKEN': csrfToken } : {}),
    },
    body: JSON.stringify(data),
  });
}

// ── 1. 文件上传 ────────────────────────────────────────────────────────────────
export async function uploadFile(file) {
  const form = new FormData();
  form.append('file', file);
  const res = await request('/api/common/uploadFile', { method: 'POST', body: form });
  if (res.result && res.result.startsWith('/')) {
    res.result = `http://47.76.186.202:8080${res.result}`;
  }
  return res;
}

// ── 2. 报名 ────────────────────────────────────────────────────────────────────
export function sendRegisterCode(email, companyName, local) {
  return post('/api/auth/register/send-code', { email, companyName, local: toApiLocale(local) });
}

export function register(data) {
  const { pageLang, ...rest } = data;
  return post('/api/auth/register', {
    ...rest,
    ...(pageLang != null ? { pageLang: toApiLocale(pageLang) } : {}),
  });
}

// ── 3. 激活 ────────────────────────────────────────────────────────────────────
export function activatePreview(id) {
  return post('/api/auth/activate/preview', { id });
}

export function sendActivateCode(id, local) {
  return post('/api/auth/activate/send-code', { id, local: toApiLocale(local) });
}

export function activate(id, verifyCode, password) {
  return post('/api/auth/activate', { id, verifyCode, password });
}

// ── 4. 登录 / 会话 ─────────────────────────────────────────────────────────────
export async function login(username, password) {
  await fetch(`${BASE}/api/auth/session`, { credentials: 'include' }).catch(() => {});
  return csrfPost('/api/auth/login', { username, password });
}

export function getSession() {
  return request('/api/auth/session');
}

export function getMe() {
  return request('/api/auth/me');
}

export function logout() {
  return csrfPost('/api/auth/logout', {});
}

// ── 5. 忘记密码 ───────────────────────────────────────────────────────────────
export function sendForgotPasswordCode(account, local) {
  return post('/api/auth/password/forgot/send-code', { account, local: toApiLocale(local) });
}

export function resetPassword(account, verifyCode, password) {
  return post('/api/auth/password/forgot/reset', { account, verifyCode, password });
}

// ── 6. 企业信息更新 ────────────────────────────────────────────────────────────
export function updateEnterpriseInfo(id, data) {
  return post('/api/backend/application/update', { id, ...data });
}

export function updateProfile(data) {
  return post('/api/auth/profile/update', data);
}
export function getSurveyPaper(local) {
  return post('/api/survey/paper', { local: toApiLocale(local) });
}

export function getSurveyProgress(enterpriseId) {
  return post('/api/survey/progress', enterpriseId ? { enterpriseId } : {});
}

export function submitSurvey(enterpriseId, status, answers) {
  return post('/api/survey/submit', { enterpriseId, status, answers });
}
